import React from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
}                                       from '@material-ui/core';

import { makeStyles, useTheme }         from '@material-ui/core/styles';

import { PieChart }                     from 'react-minimal-pie-chart';

import { 
  fmtDaysHrsMinFromSecs as fmtSecs,
}                                       from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
  },
  table: {
    minWidth: 250,
    },
  cell: {
    padding: 0,
  },
  workload: {
    backgroundColor: theme.palette.primary.main,
  },
  controller: {
    backgroundColor: theme.palette.warning.main,
  },
  transfer: {
    backgroundColor: 'grey',
  },
}));

export default function ExecutionTimings(props) {
    
  const { value, variant } = props;
  
  const classes = useStyles();

  const theme = useTheme();
  const timings = value.Metrics.Seconds;

  const transferColor = 'grey';
  const workloadColor = theme.palette.primary.main;
  const controllerColor = theme.palette.warning.main;

  const overallSecs = timings.Overall || 0;
  const downloadSecs = timings.Download || 0;
  const workloadSecs = timings.Workload || 0;
  const uploadSecs = timings.Upload || 0;
  const transferSecs = downloadSecs + uploadSecs;
  const controllerSecs = (overallSecs - transferSecs - workloadSecs) || 0;
  
  const totalCompleted = value.Inputs.Failed.Objects + value.Inputs.Skipped.Objects + value.Inputs.Succeeded.Objects;

  if(variant==='table') {
    return (
      <TableContainer className={classes.root}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.cell}><Typography variant='caption'>Activity</Typography></TableCell>
              <TableCell className={classes.cell} align="right"><Typography variant='caption'>Total Time</Typography></TableCell>
              <TableCell className={classes.cell} align="right"><Typography variant='caption'>Avg/Input</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.cell}><Typography variant='caption'>Overall</Typography></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(overallSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(overallSecs/totalCompleted,'s')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><i><Typography variant='caption'><span className={classes.transfer}>&nbsp;</span>&nbsp;Download</Typography></i></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(downloadSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(downloadSecs/totalCompleted,'s')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><i><Typography variant='caption'><span className={classes.workload}>&nbsp;</span>&nbsp;Workload</Typography></i></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(workloadSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(workloadSecs/totalCompleted,'s')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><i><Typography variant='caption'><span className={classes.controller}>&nbsp;</span>&nbsp;Controller</Typography></i></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(controllerSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(controllerSecs/totalCompleted,'s')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><i><Typography variant='caption'><span className={classes.transfer}>&nbsp;</span>&nbsp;Upload</Typography></i></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(uploadSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(uploadSecs/totalCompleted,'s')}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  } else {
    return(
      <div>
        <PieChart style={{ height: '75px' }}
          animate
          paddingAngle={5}
          lengthAngle={350}
          startAngle={275}
          data={[
            { title: 'Download', value: downloadSecs, color: transferColor },
            { title: 'Workload', value: workloadSecs, color: workloadColor },
            { title: 'PostProcess', value: controllerSecs, color: controllerColor },
            { title: 'Upload', value: uploadSecs, color: transferColor },
          ].filter((item) => item.value>0)}
        />
      </div>
    );
  }
}

ExecutionTimings.propTypes = {
  value: PropTypes.object.isRequired,
  variant: PropTypes.string.isRequired,
};

ExecutionTimings.defaultProps = {
  variant: 'table',
};

        // <PieChart style={{ height: '75px' }}
        //   animate
        //   //rounded
        //   lineWidth={30}
        //   paddingAngle={5}
        //   lengthAngle={360}
        //   startAngle={270}
        //   label={() => Math.round(((overallSecs-workloadSecs)*100)/overallSecs)+"%"}
        //   labelStyle={{
        //     fontSize: '20px',
        //     fontFamily: 'sans-serif',
        //     //fill: '#E38627',
        //   }}
        //   labelPosition={0}
        //   data={[
        //     { title: 'Workload', value: workloadSecs, color: 'orange' },
        //     { title: 'Download', value: downloadSecs, color: 'blue' },
        //     { title: 'PostProcess', value: postProcessSecs, color: 'blue' },
        //     { title: 'Upload', value: uploadSecs, color: 'blue' },
        //   ].filter((item) => item.value>0)}
        // />
